import React from "react";
import TopBar from "../dashboard/TopBar";

const OperatorNavBar = ({ toggleSidebar }) => (
  <TopBar toggleSidebar={toggleSidebar} />
);

export default OperatorNavBar;
